import { BroadsiderHudPopup } from '../';
import { StyledMetaversePopup } from './MetaversePopup.styled';
import MetaversePopupTitle from './MetaversePopupTitle';
import MetaverseSection from './MetaverseSection';

const PopupContent = ({ content, forHomePage = false, collapsed = false, setCollapsed }) => {
  return (
    <StyledMetaversePopup $solid={forHomePage}>
      {forHomePage && !collapsed && setCollapsed && <div className='metaverse-collapse' onClick={() => setCollapsed ? setCollapsed(!collapsed) : false}>
        <img src='/assets/try_left.svg' /> 
      </div>}
      <div className='metaverse-screen'>
        <div className='metaverse-content'>
          <MetaversePopupTitle forHomePage={forHomePage}/>
          <div className='metaverse-sections'>
            {content.map((c) => (<MetaverseSection title={c.category} items={c.items}/>))}
            <div className='metaverse-sections-placeholder' />
          </div>
        </div>
      </div>
      {/*<div className='metaverse-decorator'/>*/}
    </StyledMetaversePopup>
  );
}
const MetaversePopup = ({ content, forHomePage = false, standalone = false, collapsed, setCollapsed  }) => {
  const order = {
    'featured': 0,
    'games': 1,
    'worlds': 2,
    'communities': 3,
    'streaming tools': 4,
    'creator tools': 5
  };
  const orderedContent = content.sort((a, b) => {
    const aOrder = order[a.category.toLowerCase()] || 0;
    const bOrder = order[b.category.toLowerCase()] || 0;
    return aOrder - bOrder;
  });

  if (standalone) {
    return (<PopupContent content={orderedContent} forHomePage={forHomePage}/>);
  }
  return (
    <BroadsiderHudPopup right={forHomePage} collapsed={collapsed}>
      <PopupContent content={orderedContent} forHomePage={forHomePage} collapsed={collapsed} setCollapsed={setCollapsed}/>
    </BroadsiderHudPopup>
  );
};

export default MetaversePopup;
